import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { FaHistory, FaPen, FaSave, FaSpinner } from "react-icons/fa";
import { MdClose, MdOutlineArrowBack } from "react-icons/md";
import PageContainer from "../../../components/PageContainer";
import useAlertNotification from "../../../context/AlertNotificationContext";
import PercentuaisApiService from "../../../services/api/PercentuaisApiService";
import Loading from "../../../components/Loading";
import PercentuaisFinanceirosForm from "./PercentuaisFinanceirosForm";
import CustomModal from "../../../components/CustomModal";
import PercentuaisFinanceirosTabelaHistorico from "./PercentuaisFinanceirosTabelaHistorico";
import useAuth from "../../../context/AuthContext";

const PercentuaisFinanceiros = () => {
  const history = useHistory();
  const alert = useAlertNotification();
  const { user } = useAuth();

  const [formData, setFormData] = useState({});
  const [origData, setOrigData] = useState({});
  const [edit, setEdit] = useState(false);
  const [isEdited, setIsEdited] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [historyData, setHistoryData] = useState([]);

  const isFormEdited = () => {
    return edit && JSON.stringify(formData) !== JSON.stringify(origData);
  };

  const validateFields = () => {
    const errors = [];
  
    const percentuais = [
      { name: "impostosResultadoBruto", label: "Impostos sobre Resultado Bruto" },
      { name: "impostosAntesIrCsll", label: "Impostos antes do IR/CSLL" },
      { name: "rv", label: "RV" },
      { name: "despesaOperacional", label: "Despesa Operacional" },
      { name: "rateioAdministrativo", label: "Rateio Administrativo" },
      { name: "beneficiosColaboradorSimulacao", label: "Valor de Benefícios em Simulações" },
      { name: "cargoConfianca", label: "Cargo de Confiança" },
      { name: "trienio", label: "Triênio" },
      { name: "metaTurnover", label: "Meta de Turnover" },
      { name: "metaCapacidade", label: "Meta de Capacidade" }    
    ];
  
    percentuais.forEach(({ name, label }) => {
      const valor = parseFloat(formData[name]);
      if ((isNaN(valor) || valor < 0 || valor > 100) && name != "beneficiosColaboradorSimulacao") {
        errors.push(`${label} deve estar entre 0 e 100.`);
      }
    });
  
    return errors;
  };

  const handleSave = async () => {

    const errors = validateFields();

    if (errors.length > 0) {
      alert.error(errors.join("\n"));
      return;
    }

    try {
      setIsSaving(true);

      const updatedFormData = {
        ...formData,
        origem: user.email
      };

      const resp = await PercentuaisApiService.updatePercents(updatedFormData);
      if (resp.data) {
        setOrigData(updatedFormData);
        setFormData(updatedFormData);
        setEdit(false);
        setIsEdited(false);
        alert.success("Valores financeiros salvos com sucesso!");

        const history = await PercentuaisApiService.getPercentsHistory();
        setHistoryData(history.data);
      }
    } catch (err) {
      alert.error("Erro ao salvar os valores financeiros: " + err.message);
      console.error(err);
    } finally {
      setIsSaving(false);
    }
  };

  const openModalHistorico = () => {
    CustomModal.show({
      title: "Histórico dos valores financeiross",
      body: (
        historyData.length ?
          <PercentuaisFinanceirosTabelaHistorico dataHistory={historyData} />
           : <>Não há dados de histórico para exibir.</>
      ),
      size: "xl"
    });
  }

  const onChange = (ev) => {
    const { name, value } = ev.target;
    const updated = { ...formData, [name]: value };
    setFormData(updated);
  };

  const onEdit = () => {
    if (isFormEdited() && !isEdited) {
      setIsEdited(true);
    }
  };

  const loadData = async () => {
    try {
      setIsLoading(true);

      const [data, history] = await Promise.all([
        PercentuaisApiService.getPercents(),
        PercentuaisApiService.getPercentsHistory()
      ]);

      const finalData = data?.data ?? {};

      setFormData(finalData);
      setOrigData(finalData);
      setHistoryData(history.data);
    } catch (err) {
      alert.error("Erro ao carregar os valores financeiros.");
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  useEffect(onEdit, [formData]);

  const actions = [
    {
      label: "Histórico",
      icon: <FaHistory />,
      color: "info",
      type: "button",
      disabled: isLoading,
      onClick: openModalHistorico
    },
    ...(!edit
      ? [
        {
          label: "Editar",
          icon: <FaPen />,
          color: "primary",
          type: "button",
          onClick: () => setEdit(true)
        }
      ]
      : [
        {
          label: isSaving ? "Salvando..." : "Salvar",
          icon: isSaving ? <FaSpinner /> : <FaSave />,
          color: "success",
          type: "button",
          disabled: isSaving,
          onClick: handleSave
        }
      ]),
    (!edit ? {
      label: 'Voltar',
      icon: <MdOutlineArrowBack />,
      color: 'info',
      type: 'button',
      onClick: () => history.goBack()
    } : {
      label: 'Cancelar',
      icon: <MdClose />,
      color: 'danger',
      type: 'button',
      onClick: () => window.location.reload()
    })
  ];

  return (
    <PageContainer title="Valores Financeiros Gerais" actions={actions}>
      {isLoading ? (
        <Loading message="Carregando dados..." />
      ) : (
        <>
        <PercentuaisFinanceirosForm
          data={formData}
          onChange={onChange}
          disabled={!edit}
        /><CustomModal/></>
      )}
    </PageContainer>
  );
};

export default PercentuaisFinanceiros;
